import React from 'react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import Header from '../../components/Header/Header.js';
import Footer from '../../components/Footer/Footer.js';

import styles from './CareersPageStyles';
import CareersForm from './Form/CareersForm';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import Slogan from '../../components/Slogan/Slogan';
import { HEADER_LINK_IDS } from '../../components/Header/HeaderLinks';

const CareersPage = props => {
    const { classes } = props;
    return (
        <div>
            <Header
                color="transparent"
                fixed
                changeColorOnScroll={{
                    height: 1,
                    color: 'white'
                }}
                activeTab={HEADER_LINK_IDS.CAREERS}
            />
            <Slogan parallax="parallax90hv" />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <CareersForm />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default compose(
    withStyles(styles),
    withTranslation()
)(CareersPage);
